import React from 'react';

const ComponentInterview = (props) => {
  const { isSelected, video_url, url, body } = props;
  return (
    <div className={isSelected ? 'interview interview--selected' : 'interview'}>
      <div className="notice-view__body" dangerouslySetInnerHTML={{ __html: body }}></div>
      <a target="_blank" href={video_url}>Video</a>
      <a target="_blank" href={url}>Original</a>
    </div>
  );
};

export default ComponentInterview;



// WEBPACK FOOTER //
// ./src/components/ListEntity/Entities/Interview.js